import { render, staticRenderFns } from "./setPointModal.vue?vue&type=template&id=3d4ec62c&"
import script from "./setPointModal.vue?vue&type=script&lang=js&"
export * from "./setPointModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports